import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';

export const useTrackOpenedWorkspacePopover = () => {
  const { track } = useAnalyticsUtilities();

  const trackOpenedWorkspacePopover = useCallback(() => {
    track(`Opened workspace popover`);
  }, [track]);

  return { trackOpenedWorkspacePopover };
};
